import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from "react-router-dom"
import { BaseUrl } from '../../helper/BaseUrl';
import { DateConvert } from '../../helper/DateConvert';
import Icons from '../../myIcon/Icons';
import { getMediaUrl } from '../../helper/mediaUrl';

export default function BlogContent({ initialData, setBlogTitle }) {
  const { blog_slug } = useParams();
  const [aiData, setAiData] = useState(initialData || {});
  const image1Url = getMediaUrl(aiData?.image1);
  const image2Url = getMediaUrl(aiData?.image2);
  const [pageUrl, setPageUrl] = useState("");
  const [copied, setCopied] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    if (typeof window !== "undefined") {
      setPageUrl(window.location.href);
    }
  }, []);

  const handleCopy = async () => {
    if (typeof window !== "undefined" && pageUrl) {
      try {
        await navigator.clipboard.writeText(pageUrl);
        setCopied(true);
        setTimeout(() => setCopied(false), 10000); // reset after 10s
      } catch (err) {
        console.error("Copy failed:", err);
      }
    }
  };
  useEffect(() => {
    const aifetcher = async () => {
      try {
        const response = await fetch(`${BaseUrl}/api/blog/view/${blog_slug}`, {
          method: 'GET',
        });
        const result = await response.json();
        if (!result.blog) {
          navigate("/404", { replace: true });
          return;
        }
        setAiData(result.blog);
        setBlogTitle(result.blog?.title || "");
      } catch (error) {
        console.error('Fetch error:', error.message);
      }
    };
    aifetcher();
  }, [blog_slug, navigate, setBlogTitle]);



  return (
    <>
      <section className="blogdetail-content-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="blog-detail-head">
                <div className="detail-date">
                  <span className="date"> {DateConvert(aiData?.date)} </span> | <span> {`${Math.round(aiData?.description1?.length / 200)} Min Read`}
                  </span>
                </div>
                <h1 className="heading">{aiData?.title}</h1>
                <div className="blog-detail-user-wrap">
                  <div className="detail-subtitle">
                    <p>{aiData?.brief}</p>
                  </div>
                  <div className="blog-detail-social">
                    <div className="detail-social-inner">
                      <span>Share:  </span>
                      <ul>
                        <li title={copied ? "Copied!" : "Copy link"} >
                          <a onClick={handleCopy} > <Icons name="ShareLink" /> </a>
                        </li>
                        <li >
                          <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/resortdecoracao/">  <Icons name="instagram" />
                          </a>
                        </li>
                        <li>
                          <a target='_blank' rel="noopener noreferrer" href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(pageUrl)}`} >  <Icons name="facebook" />
                          </a>
                        </li>
                        <li>
                          <a target="_blank" rel="noopener noreferrer" href="https://www.pinterest.com/" ><Icons name="pinterest" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <img src={getMediaUrl (aiData?.banner_image)} className="img-responsive detail-banner-img" alt={aiData?.title} />
              </div>
            </div>
            <div className="col-lg-12 col-md-12">
              <div className="blog-detail-text">
                <div className="description-wrapper"> <div dangerouslySetInnerHTML={{ __html: aiData?.description1 }} /></div>
                <div className="blog-details-img">
                  <div className="details-img1">
                    {image1Url && <img src={image1Url} className="img-responsive " alt={aiData?.alt_image1} />}
                  </div>
                  <div className="details-img2">
                    {image2Url && <img src={image2Url} className="img-responsive " alt={aiData?.alt_image2} />}
                  </div>
                </div>
                <div className="description-wrapper"> <div dangerouslySetInnerHTML={{ __html: aiData?.description2 }} /></div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  )
}

